<template>
  <CBox>
    <CBox d="flex" justifyContent="center" mt="9vw" mx="auto" mb="1.5vw">
      <CBox
        class="mediaButtons"
        d="flex"
        width="40vw"
        justifyContent="space-evenly"
      >
        <CBox
          m="1vw"
          p="0.5vw"
          w="100%"
          fontSize="1vw"
          color="#2867B2"
          borderRadius="5px"
          textAlign="center"
          class="mediaButton turnToPointer"
          outline="1px solid #2867B2"
          @click="connectOnLinkedIn"
        >
          LinkedIn
        </CBox>
        <CBox
          m="1vw"
          p="0.5vw"
          w="100%"
          fontSize="1vw"
          color="#EA4335"
          borderRadius="5px"
          textAlign="center"
          class="mediaButton turnToPointer"
          outline="1px solid #EA4335"
          @click="connectOnMail"
        >
          Mail
        </CBox>
        <CBox
          m="1vw"
          p="0.5vw"
          w="100%"
          fontSize="1vw"
          color="#1DA1F2"
          borderRadius="5px"
          textAlign="center"
          class="mediaButton turnToPointer"
          outline="1px solid #1DA1F2"
          @click="connectOnTwitter"
        >
          Twitter
        </CBox>
      </CBox>
    </CBox>
    <CHeading
      class="bottomHeading"
      textAlign="center"
      fontSize="1vw"
      mb="1vw"
      color="#6D6563"
    >
      Copyright 2021 @ Kishan Khirasariya</CHeading
    >
  </CBox>
</template>

<script>
import { CBox, CHeading } from "@chakra-ui/vue";

export default {
  name: "ConnectWithMe",
  components: {
    CBox,
    CHeading,
  },
  methods: {
    connectOnLinkedIn() {
      window.open("https://www.linkedin.com/in/kishan-khirasariya/", "_blank");
    },
    connectOnMail() {
      location.href = "mailto:kishankhirasariya.kk@gmail.com";
    },
    connectOnTwitter() {
      window.open("https://twitter.com/khirasariyak", "_blank");
    },
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .mediaButtons {
    width: 80vw;
  }
  .mediaButton {
    font-size: 2vw;
    padding: 1.25vw;
    margin: 4vw;
  }
  .bottomHeading {
    font-size: 2vw;
    margin-bottom: 5vw;
  }
}

.turnToPointer {
  cursor: pointer;
}

.turnToPointer:hover {
  outline-style: dotted;
  font-weight: bold;
}
</style>
